import useABTestValue from '@hooks/useABTestValue'

export type UseEnableTrackingDebug = () => boolean

const useEnableTrackingDebug: UseEnableTrackingDebug = () =>
  useABTestValue('showTrackingDebugView') === 'show'

export default useEnableTrackingDebug
